import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { addDataModalActions } from '../../../redux/profiles/patientHealthboard/add-data-modal';
import {
  selectOpenedAddDataModal,
  selectTypeAddDataModal,
} from '../../../redux/profiles/patientHealthboard/selectors';

const mapStateToProps = state => ({
  openedAddDataModal: selectOpenedAddDataModal(state),
  type: selectTypeAddDataModal(state),
});

const mapDispatchToProps = {
  close: addDataModalActions.close,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/AddDataModal/enhance.js